import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Range as RCRange, createSliderWithTooltip } from 'rc-slider';

import { isTruthy } from 'lib/Helpers';

import { formatValueString, getHandleStyle, getTrackStyle } from './utils';
import * as styles from './Slider.scss';

export const Range = createSliderWithTooltip(RCRange);

/**
 * @class Slider
 * @classdesc Reusable Slider Component
 * @property state
 * @example ./Slider.md
 */
export default class Slider extends Component {
  static propTypes = {
    className: PropTypes.string,
    defaultValues: PropTypes.arrayOf(PropTypes.number),
    disabled: PropTypes.bool,
    handleChange: PropTypes.func.isRequired,
    max: PropTypes.number.isRequired,
    min: PropTypes.number.isRequired,
    resetValues: PropTypes.bool,
    sliderClassName: PropTypes.string,
    style: PropTypes.objectOf(
      PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
      ]),
    ),
    type: PropTypes.string,
    stepSize: PropTypes.number,
  };

  static defaultProps = {
    className: null,
    defaultValues: [],
    disabled: false,
    resetValues: false,
    sliderClassName: null,
    style: null,
    type: null,
    stepSize: 1,
  };

  constructor(props) {
    super(props);

    this.state = {
      rangeValues: [props.min, props.max],
    };
    this.railStyle = { backgroundColor: '#D5E5FC', width: '100%' };
  }

  static getDerivedStateFromProps(nextProps) {
    const { min, max, resetValues } = nextProps;

    return resetValues
      ? { rangeValues: [min, max] }
      : null;
  }

  componentDidMount() {
    const { defaultValues } = this.props;

    return isTruthy(defaultValues)
      ? this.onChange(defaultValues)
      : null;
  }

  /**
   * onChange handler that checks lower & upper boundaries
   * @param {number} value
   * @return {Function} this.setState
   */
  onChange = value => {
    return this.setState({ rangeValues: value });
  };

  /**
   * onChange Handler called once the slider handle is dropped
   * @return {Function} props.handleChange
   */
  onAfterChange = value => {
    const { handleChange } = this.props;
    return handleChange(value);
  };

  render() {
    const {
      className,
      disabled,
      min,
      max,
      sliderClassName,
      style,
      stepSize,
      type,
    } = this.props;
    const { rangeValues } = this.state;

    return (
      <div className={classNames(styles.sliderWrapper, className)} style={style}>
        <div className={styles.sliderBackgroundWrapper} />
        <Range
          allowCross={false}
          className={classNames(styles.slider, sliderClassName)}
          disabled={disabled}
          handleStyle={getHandleStyle(disabled)}
          min={min}
          max={max}
          onAfterChange={this.onAfterChange}
          onChange={this.onChange}
          railStyle={this.railStyle}
          step={stepSize}
          trackStyle={getTrackStyle(disabled)}
          tipFormatter={value => formatValueString({ type, value })}
          value={rangeValues} />
        <div className={styles.values}>
          <span className={styles.minValue}>{min}</span>
          <span className={styles.maxValue}>{formatValueString({ type, value: max })}+</span>
        </div>
      </div>
    );
  }
}
